import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_ordenes_de_compra,coleccion_cotizaciones,db, customAuth,coleccion_entradas,numeracion_de_documentos} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp,secondsToFormatDateInput} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        datos:{
          items:[],
          proveedor:[],
        },
        registro:{},
        selectedKey: '',
      },
      mutations: {
        getAllItems(state, item) {
          Vue.set( state.registro, item.id, {...item.data(), creado_el: secondsToFullTimestamp(item.data().creado_el)} )
        },
        clean(state,key){
          Vue.delete(state.registro,key)
        }
      },
      actions: {
        
        getAll:(context)=>{
          context.state.registro = {}
          coleccion_ordenes_de_compra.onSnapshot(datos=>datos.docs.map( item => {context.commit( 'getAllItems', item  ) }) )
        }, 
        add: async ({state, commit},{datos,idCotizacion})=>{

          if(state.selectedKey=='' ){
            let increaseNumeration = await db.collection('app').doc('numeracion_de_documentos').collection('numeracion_orden_de_compra').doc('00').get()
            let nueva_numeracion = ( increaseNumeration.exists ) ? increaseNumeration.data().numeración + 1 : 1
            //aqui actualizo el estado del documento para desactivar el boton de seleccionar el proveedor
            coleccion_cotizaciones.doc(idCotizacion).update({estado_del_documento:'proveedor_seleccionado'})
            coleccion_ordenes_de_compra.add({...datos,numero_de_operacion:nueva_numeracion,estado_del_documento: 'esperando',creado_el:new Date ,creado_por:customAuth.currentUser.displayName, }).then(()=>{
              db.collection('app').doc('numeracion_de_documentos').collection('numeracion_orden_de_compra').doc('00').set({numeración:nueva_numeracion})
              commit('Helpers/launchSnackbar', 'Se ha generado una orden de compra correctamente', { root: true })
            })
          } else {
            coleccion_ordenes_de_compra.doc(state.selectedKey).update({...datos, estado_del_documento: 'procesado', procesado_el:new Date, procesado_por:customAuth.currentUser.displayName, }).then(()=>{
              commit('Helpers/launchSnackbar', 'Se ha actualizado la orden de compra correctamente', { root: true })
            })
          }
        },
        generar_orden_de_compra_directamente: async({state,commit})=>{
          if(state.selectedKey=='' ){
            let datos = state.datos
            let increaseNumeration = await db.collection('app').doc('numeracion_de_documentos').collection('numeracion_orden_de_compra').doc('00').get()
            let nueva_numeracion = ( increaseNumeration.exists ) ? increaseNumeration.data().numeración + 1 : 1
            coleccion_ordenes_de_compra.add({
              ...datos,numero_de_operacion:nueva_numeracion,
              estado_del_documento: 'esperando',
              creado_el:new Date ,
              creado_por:customAuth.currentUser.displayName,
            }).then(()=>{
              db.collection('app').doc('numeracion_de_documentos').collection('numeracion_orden_de_compra').doc('00').set({numeración:nueva_numeracion})
              commit('Helpers/launchSnackbar', 'Se ha generado una orden de compra correctamente', { root: true })
              state.selectedKey = ''  
              state.datos = {
                items:[],
                proveedor:[]
              }

            })
          } else {
            console.log('mmm',datos)
            coleccion_ordenes_de_compra.doc(state.selectedKey).update({...datos, estado_del_documento: 'procesado', procesado_el:new Date, procesado_por:customAuth.currentUser.displayName, }).then(()=>{
              commit('Helpers/launchSnackbar', 'Se ha actualizado la orden de compra correctamente', { root: true })
            })
          }
        },
        get:({state}, key)=>{
          coleccion_ordenes_de_compra.doc(key).get().then(doc=>{
            state.datos = doc.data()
            state.datos.key = key
            state.selectedKey = key
          })
        },
        
        process:async (context, { id, host}) => {
          coleccion_ordenes_de_compra.doc(id).update({estado_del_documento: 'procesando'})
          let credenciales = context.rootState.Credenciales.record
          let nombre_de_db = context.rootState.Customers.data.name
          credenciales = Object.keys(credenciales).map(item=>credenciales[item])
          let function_host = credenciales.filter(item=>item.slug == "credenciales-para-envio")[0].valores
          function_host = function_host.filter(item=>item.descripcion=="functions_confirmacion")[0].valor          
          if(!function_host)return context.commit('Helpers/launchSnackbar', 'No existe un hosting de envio de correo' , { root: true })
          let url =`${function_host}?host=${host}&base_de_datos=${nombre_de_db}`
          fetch( url, {
            method: 'POST', 
            body: JSON.stringify(context.state.datos), 
            headers:  {
              'Content-Type': 'application/json',
            },
          })
          .then(res =>{
            return res
          })
          .then(data=> { 
            context.commit('Helpers/launchSnackbar','Se ha enviado un correo al proveedor de confirmacion', { root: true }) 
          })
          .catch(error => console.log('error', error))
        },
        limpiar_selectedKey: ({state})=>{
          state.selectedKey = ""
        },
        generar_entrada: async ({state,dispatch, commit},key  )=>{
          await dispatch('add', {datos: state.datos})
          let numeracion = await numeracion_de_documentos.collection('Nota de entrada').doc('00').get()
          let nueva_numeracion = (!numeracion.exists) ? 1 : numeracion.data().numeracion + 1
          coleccion_ordenes_de_compra.doc(key).update({estado_del_documento:'comprobante generado'})
          coleccion_ordenes_de_compra.doc(key).get().then( async doc=>{
            state.datos = doc.data()
            state.datos.key = key
            let datos = state.datos
            let datos_a_grabar = {
              ...datos,
              creado_el: new Date,
              documento_de_operacion: 'Nota de entrada',
              numero_de_operacion: nueva_numeracion,
              estado_del_documento: 'esperando',
              total_igv: Number(datos.items.map(item => (item.incluye_igv) ? Number(item.valor_unitario) / 1.18 * 0.18 : 0).reduce((a, b) =>  a + b ).toFixed(2)),
              total:Number(datos.items.map(item => (item.incluye_igv) ? Number(item.cantidad) * Number(item.valor_unitario) * 1.18 : Number(item.cantidad) * Number(item.valor_unitario)).reduce((a, b) =>  a + b ).toFixed(2)),
              valor_de_venta: Number(datos.items.map(item => Number(item.cantidad) * Number(item.valor_unitario) ).reduce((a, b) =>  a + b ).toFixed(2)) ,
              total_gravada : Number( datos.items.map( item => (item.tipo_de_igv === 1) ?  Number(item.cantidad) * Number(item.valor_unitario) : 0).reduce((a, b) =>  a + b, 0 ) ),
              total_exonerada : Number( datos.items.map( item => (item.tipo_de_igv === 8) ?  Number(item.cantidad) * Number(item.valor_unitario) : 0).reduce((a, b) =>  a + b, 0 ) ),
              total_descuento : Number( datos.items.map( item=> item.descuento ).reduce((a, b) =>  a + b, 0 ) ) ,
              descuento_global : Number( datos.items.map( item=> item.descuento ).reduce((a, b) =>  a + b, 0 ) ),
              nombre_motivo_de_traslado: 'COMPRA',
              motivo_de_traslado:'002',
              mensaje:'Se ha procesado correctamente el almacén ALMACEN PRINCIPAL ',
              fecha_de_emision: new Date().toISOString().substr(0, 10), 
              proveedor_denominacion: datos.proveedor.name,
              proveedor_numero_de_documento: datos.proveedor.document,
              warehouse: await dispatch('Warehouse/getMainWarehouse', '', {root: true}),
          }
            coleccion_entradas.add(datos_a_grabar).then(() => {
              state.loading = false
              numeracion_de_documentos.collection('Nota de entrada').doc('00').set({numeracion: nueva_numeracion})
            //aqui insertaré el modulo contable
            
            let sub_total = datos_a_grabar.total_gravada
            let referencia = `${datos_a_grabar.serie_comprobante}${datos_a_grabar.numero_comprobante}${datos_a_grabar.tipo_de_comprobante} `
            let proveedor = datos_a_grabar.proveedor_denominacion
            let fecha_caducidad = datos_a_grabar.condiciones_de_pago
            dispatch('Movimientos_contables/movimiento_contable', {valor: sub_total, regla:"Compra", proveedor, fecha_caducidad, referencia, fecha: new Date}, { root: true }) 
            commit('Helpers/launchSnackbar', 'Se ha registrado la nota de entrada', { root: true })
            })
          })
        }
      },
      getters: {
        registro_de_propuestas: state =>Object.keys(state.registro_de_propuestas).map(item=> ({...state.registro_de_propuestas[item], key: item }) ),
        registro: state => Object.keys(state.registro).map(item => ({...state.registro[item], key: item }) ),
      },
  }
  